import { useState } from 'react';
import { exportAccountingPDF } from '@/lib/pdfExport';
import type { PaymentRecord, AccountingKPIs, AccountingFilters } from '@/hooks/useAccounting';
import { theme } from '@/lib/theme';

interface Props {
  payments: PaymentRecord[];
  kpis: AccountingKPIs;
  filters: AccountingFilters;
  disabled?: boolean;
}

export default function ExportPDFButton({ payments, kpis, filters, disabled }: Props) {
  const [exporting, setExporting] = useState(false);

  const handleExport = async () => {
    if (exporting || disabled || payments.length === 0) return;
    setExporting(true);
    try {
      // Small delay so the spinner renders before the heavy PDF work
      await new Promise((r) => setTimeout(r, 80));
      exportAccountingPDF(payments, kpis, filters);
    } finally {
      setExporting(false);
    }
  };

  const isEmpty = payments.length === 0;

  return (
    <button
      onClick={handleExport}
      disabled={exporting || disabled || isEmpty}
      title={isEmpty ? 'Sin datos para exportar' : 'Exportar reporte PDF'}
      className="flex items-center gap-2 px-4 py-2 rounded-lg text-xs font-semibold transition-all cursor-pointer whitespace-nowrap disabled:opacity-40 disabled:cursor-not-allowed"
      style={{
        backgroundColor: exporting ? 'rgba(52,211,153,0.08)' : 'rgba(52,211,153,0.10)',
        color: '#34d399',
        border: '1px solid rgba(52,211,153,0.22)',
      }}
    >
      <div className="w-3.5 h-3.5 flex items-center justify-center">
        {exporting ? (
          <i className="ri-loader-4-line text-xs animate-spin" />
        ) : (
          <i className="ri-file-pdf-2-line text-xs" />
        )}
      </div>
      {exporting ? 'Generando…' : 'Exportar PDF'}
    </button>
  );
}
